import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description CCGuaranteed icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CCGuaranteed } from '@sravni/design-system-icons'
 *
 * <CCGuaranteed />
 * ```
 */
var CCGuaranteed = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "CCGuaranteed", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3.236 6.667h15M6.57 10.758h3.334M9.903 14.167h-5c-.92 0-1.667-.746-1.667-1.667V5c0-.92.746-1.667 1.667-1.667H16.57c.92 0 1.666.746 1.666 1.667v4.167M15.736 17.5s2.5-1.2 2.5-3v-2.1l-1.823-.656a1.992 1.992 0 0 0-1.355 0l-1.822.656v2.1c0 1.8 2.5 3 2.5 3Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { CCGuaranteed };
//# sourceMappingURL=CCGuaranteed.js.map
